// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Legacy redirect route for /items.
 * Redirects to /catalog/items, preserving search params.
 */
import { itemsSearchParamsSchema } from '@/items/api/types';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/items/')({
  validateSearch: itemsSearchParamsSchema,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/catalog/items',
      search,
    });
  },
});
